import React, { useState, useEffect } from "react";

export const ResponseMessage = (props) => {
  const [message, setMessage] = useState();

  useEffect(() => {
    const status = props.status;
    if (status === "failure") {
      setMessage(
        <div id="hideFailure">
          Sorry but no test results with that batch ID can be found. Please
          double check the entered batch ID or{" "}
          <a
            href="https://haloinfusions.com/contact-us__trashed/halo-help-request/"
            target="_blank"
            rel="noopener noreferrer"
          >
            contact us
          </a>{" "}
          if you think the results should be here. Thanks!
        </div>
      );
    } else if (status === "pending") {
      setMessage(
        <div id="reportPending">
          The full report is pending from the lab. Check back later for it and
          see up to date results summarized above.
        </div>
      );
    } else if (status === "badRequest") {
      setMessage(
        <div id="badRequest">
          You've made an invalid request. You may have strange characters in
          your request like emojiis or similar. We promise theres no emojiis in
          our batch ids so please try again!
        </div>
      );
    } else if (status === "empty") {
      setMessage(<div id="noID">Please enter a Batch ID</div>);
    } else if (status === "loading") {
      setMessage(<div id="loading">Loading...</div>);
    } else {
      setMessage(null);
    }
  }, [props.status]);

  return <>{message}</>;
};
